import getAPIDomain from '@signal/utils/env/apiDomain';
export var API_URL = getAPIDomain('/menu/service');
export var API_VERSION = '1.0';
export var RENDER_AS_MENU = 'menu';
export var RENDER_AS_HEADER = 'header';
export var RENDER_AS_BOTH = 'both';
export var RENDER_AS_SELECT = 'select';